import React from "react";

export default function PuzRow({ rowIndex, row, selectedWord, positions, onCellClick }) {
    const isFoundInPositions = (row, col) => {
        return positions.some(position => position.row === row && position.col === col);
    };

    const handleCellClick = (colIndex) => {
        if (onCellClick) {
            onCellClick(rowIndex, colIndex);
        }
    };

    return (
        <div style={{ display: "flex", gap: "1px" }}>
            {row.map((cell, colIndex) => {
                const isHighlighted = selectedWord && isFoundInPositions(rowIndex, colIndex);
                
                return (
                    <div
                        key={colIndex}
                        onClick={() => handleCellClick(colIndex)}
                        style={{
                            width: "50px",
                            height: "50px",
                            border: "1px solid #ccc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "16px",
                            fontWeight: "bold",
                            backgroundColor: isHighlighted ? "#ffeb3b" : (cell ? "#fff" : "#f5f5f5"),
                            color: isHighlighted ? "#000" : (cell ? "#000" : "#999"),
                            cursor: onCellClick ? "pointer" : "default"
                        }}
                    >
                        {cell || ""}
                    </div>
                );
            })}
        </div>
    );
}

